module.exports = __webpack_public_path__ + "static/img/img-title.890323d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-title.png
// module id = +yfV
// module chunks = 1